import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { featureFlags } from '@dvag/dfs-constant-config';
import { useGetPolicies } from './useGetPolicies';

const READ_ONLY_POLICY = 'app-api-vp-digital.anwendung.lesen';

export const useReadOnlyMode = () => {
  const useNewPermissionsApi = useFeatureIsOn(featureFlags.canUsePermissionsApi);

  const { data: policyData } = useGetPolicies({
    enabled: useNewPermissionsApi,
  });

  if (!useNewPermissionsApi) {
    return false;
  }

  return policyData?.policies.includes(READ_ONLY_POLICY) ?? false;
};
